import React from "react";
import Profile from "../../Reuseable/Profile";
const StarProfile = () => {
  return (
    <>
      <Profile />
    </>
  );
};

export default StarProfile;
